import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function queryNegativeProfitOrderFunc(requestBody) {
  return request({
    url: URL.finance.negativeProfitOrder.query,
    method: 'post',
    data: requestBody
  })
}

export function handleNegativeProfitOrderFunc(requestBody) {
  return request({
    url: URL.finance.negativeProfitOrder.handle,
    method: 'post',
    data: requestBody
  })
}

export function manualGenerateNegativeProfitOrderFunc() {
  return request({
    url: URL.finance.negativeProfitOrder.manualGenerate,
    method: 'post'
  })
}
